import { render } from "./Main.vue?vue&type=template&id=3c0efb2c"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=3c0efb2c&lang=css"
script.render = render

export default script